import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { CandidateLayout } from "layouts/pages/CandidateLayout";

import { checkIsNotFound } from "configs/unsupport-locale-routes";
import { UrlsConfig } from "configs/urlsConfig";
import { Theme } from "constants/enum";
import content from "content/candidate/common";
import { serverSideTranslations } from "utils/next/translations";

export default function Candidate() {
    const { t } = useTranslation("global");
    const { locale } = useUTSLocaleContext();

    const pageContent = content(t, {
        locale,
    });

    return <CandidateLayout {...pageContent} />;
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    if (checkIsNotFound(UrlsConfig.CANDIDATE, locale)) {
        return { notFound: true };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, ["global", "candidate"])),
            withHeader: false,
            withFooter: false,
            key: locale,
            themeType: Theme.SYT,
        },
    };
};
